<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div class="p-8" v-if="step == 1">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Forget Password</h4>
                  <p>Please enter your email account.</p>
                </div>
                <vs-input type="email" label-placeholder="Email" v-model="email" class="w-full mb-6" />
                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <vs-button type="border" to="/auth/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go Back To Login</vs-button>
                  <vs-button class="w-full sm:w-auto" @click="sendMail">Send Email Verification</vs-button>
                </div>

              </div>
              <div v-else class="mb-4">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Reset Password</h4>
                  <p>Please enter your code.</p>
                </div>
                <vs-input type="text" label-placeholder="Reset Code" v-model="code" class="w-full mb-6" />
                <vs-input type="password" label-placeholder="New Password" v-model="password" class="w-full mb-6" />
                <vs-input type="password" label-placeholder="Confirm Password" v-model="confirm" class="w-full mb-6" />
                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <vs-button class="w-full sm:w-auto" @click="verify">Set New Password</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios';
export default {
  data() {
    return {
      email: '',
      code: '',
      password: '',
      confirm: '',
      step: 1,
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != '' && this.password != '';
    },
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()
        this.$vs.notify({
          title: '',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        });
        return false
      }
      return true
    },
    async sendMail(){
      this.$vs.loading();
      try {
        await axios.post('api/site/forget-password', {email:this.email});
        this.$vs.dialog({
          color:'primary',
          title: 'Email Send',
          text: 'A confirmation email has been sent to you. Please click the embedded link in the email and then enter your password.',
          accept:()=>{
            this.step = 2;
          }
        })
      }catch (e) {
        this.$vs.dialog({
          color:'danger',
          title: 'Error',
          text: 'Bad Data ',
          accept:()=>{
            this.step = 2;
          }
        })
      } finally {
        this.$vs.loading.close();

      }


    },
    async verify(){
      this.$vs.loading();
      await axios.post('api/site/reset-password', {email:this.email , code:this.code, password:this.password}).catch(err=>{
        this.$vs.dialog({
          color:'danger',
          title: 'Error',
          text: 'Error during process',
          accept:()=>{

          }
        })
      });
      this.$vs.loading.close();

      this.$vs.dialog({
        color:'primary',
        title: 'Password Reset',
        text: 'You successfully changed your password. Please proceed to log in',
        accept:()=>{
          this.$router.push('/auth/login').catch(() => {

          })
        }
      })
    },
    loginJWT() {
      if (!this.checkLogin()) return
      // Loading
      this.$vs.loading()
      const payload = {
        userDetails: {
          email: this.email,
          password: this.password
        }
      };
      this.$store.dispatch('auth/loginJWT', payload)
        .then(() => { this.$vs.loading.close() })
        .catch(({code , response}) => {
          let msg = this.$t('Error Login ');
          if(response && response.status == 422){
           msg = response.data.message;
          }
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: msg,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    registerUser() {
      if (!this.checkLogin()) return
      this.$router.push('/auth/register').catch(() => {})
    }
  }
}

</script>

<style lang="scss">
  .login-tabs-container {
    min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      margin-top: 1rem;
    }
  }
</style>

